import React from 'react'
import { motion } from 'framer-motion'
import { useAppStore } from '@/hooks/useAppStore'
import { Atmosphere } from '@/components/shared/Atmosphere'

// ─── Mode Screen ────────────────────────────────────────────────────────────────
// Dedicated "How would you like to explore?" step between the cinematic landing
// and the quiz. Two large portal cards in Yonder voice — Speak is an honest
// COMING SOON, non-interactive; Tap & Type proceeds to the quiz.

export function ModeScreen() {
  const setScreen = useAppStore((s) => s.setScreen)

  return (
    <div className="yonder-world flex flex-col min-h-screen">
      <Atmosphere density="low" />

      {/* Header */}
      <div className="relative z-10 flex items-center justify-between px-5 sm:px-8 py-5">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-sun to-sun-light flex items-center justify-center text-lg shadow-glow-sun">
            🧭
          </div>
          <div>
            <div className="text-base font-black leading-none text-white">
              Yon<span className="text-sun-pale">der</span>
            </div>
            <div className="text-[9px] font-semibold text-white/60 leading-none mt-0.5 tracking-widest uppercase">
              by Imaginarium
            </div>
          </div>
        </div>
        <button
          onClick={() => setScreen('welcome')}
          className="text-[11px] font-bold text-white/80 bg-white/10 border border-white/20 backdrop-blur-sm px-4 py-1.5 rounded-full hover:bg-white/20 transition-colors"
        >
          ← Back
        </button>
      </div>

      {/* Body */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-5 py-6 text-center">
        <div className="text-[10px] font-black tracking-[0.2em] text-sun-pale uppercase mb-3">
          Welcome to Yonder
        </div>
        <h1 className="font-black text-white text-3xl sm:text-4xl leading-tight mb-2 tracking-tight max-w-lg">
          How would your family<br className="hidden sm:block" /> like to explore?
        </h1>
        <p className="text-white/70 font-semibold text-sm mb-8 max-w-md">
          Our guide will discover your perfect family holiday.
        </p>

        <div className="grid sm:grid-cols-2 gap-4 w-full max-w-2xl">
          {/* Speak — coming soon */}
          <motion.div
            whileHover={{ y: -2 }}
            className="relative rounded-3xl p-6 text-left bg-white/5 border-2 border-white/10 backdrop-blur-sm cursor-not-allowed select-none"
          >
            <div className="absolute top-4 right-4 bg-aqua/20 border border-aqua/50 text-aqua-light text-[9px] font-black uppercase tracking-widest px-2.5 py-1 rounded-full">
              Coming soon
            </div>
            <div className="w-14 h-14 rounded-2xl bg-aqua/15 border border-aqua/40 flex items-center justify-center text-2xl mb-4">
              🎙
            </div>
            <div className="text-xl font-black text-white mb-1.5">Speak</div>
            <p className="text-[13px] font-semibold text-white/60 leading-relaxed mb-3">
              Have a natural conversation with our AI guide. Just talk — Yonder listens.
            </p>
            <span className="inline-block text-[9px] font-black uppercase tracking-wider bg-white/10 text-white/60 px-2.5 py-1 rounded-full">
              Voice · AI
            </span>
          </motion.div>

          {/* Tap & Type — active */}
          <motion.button
            onClick={() => setScreen('quiz')}
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.98 }}
            className="relative rounded-3xl p-6 text-left bg-gradient-to-br from-white/95 to-[#FFF3E2] border-2 border-sun-light/70 shadow-glow-sun transition-all"
          >
            <div className="w-14 h-14 rounded-2xl bg-sun-ultra border border-sun-light flex items-center justify-center text-2xl mb-4">
              👆
            </div>
            <div className="text-xl font-black text-ink mb-1.5">Tap &amp; Type</div>
            <p className="text-[13px] font-semibold text-ink-3 leading-relaxed mb-3">
              Quick tap choices or type freely — elegant, visual, unhurried, fun for the whole family.
            </p>
            <span className="inline-block text-[9px] font-black uppercase tracking-wider bg-sun text-white px-2.5 py-1 rounded-full">
              Touch · Text
            </span>
          </motion.button>
        </div>
      </div>
    </div>
  )
}
